/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import ClientInfo from './ClientInfo/ClientInfo';
import Message from '../../Common/Message/Message';
import './Billing.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Billing extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
            original_payout_option: 'check-at-close',
            validation: {
                client_name: {
                    valid: null,
                    msg: ''
                },
                billing_address_1: {
                    valid: null,
                    msg: ''
                },
                client_email: {
                    valid: null,
                    msg: ''
                },
                client_phone: {
                    valid: null,
                    msg: ''
                },
                billing_city: {
                    valid: null,
                    msg: ''
                },
                billing_country: {
                    valid: true,
                    msg: ''
                },
                billing_state: {
                    valid: true,
                    msg: ''
                },
                billing_contact: {
                    valid: null,
                    msg: ''
                },
                billing_zip: {
                    valid: null,
                    msg: ''
                }
            },
            isReadyToSubmit : false,
            isDisabled: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            stripe_accounts: [],
            code: '',    
            token: '',
            isSplit: false,
        };
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    handleChange = (e) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        const client = {...this.state.client};
        if (name === 'country') {
            this.state.client.country === 'US' ? client['state'] = 'AB' : client['state'] = 'AL'
        }
        client[name] = value;
        this.setState({ client });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, name, validationRegEx, e);
        }
    }

    handleChangePayout = (e) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        const client = {...this.state.client};
        if (name === 'country') {
            this.state.client.country === 'US' ? client['state'] = 'AB' : client['state'] = 'AL'
        }
        client[name] = value;
        this.setState(
            { 
                client,
            },
            () => {
                //this.updateClient();
            }
        );
    }

    handleBillingAddressChange = (value) => {
        const client = {...this.state.client};
        client.billing_address_1 = value;
        this.setState({
            client,
        });
    }

    handleFullBillingAddressChange = (value) => {
        const { client } = this.state;
        const { validation } = this.state;
        client['billing_address_1'] = `${value.address}`;
        client['billing_city'] = `${value.city}`;
        client['billing_country'] = `${value.country}`;
        client['billing_state'] = `${value.state}`;
        client['billing_zip'] = `${value.zip}`;
        validation['billing_address_1']['valid'] = true;
        validation['billing_city']['valid'] = true;
        validation['billing_country']['valid'] = true;
        validation['billing_state']['valid'] = true;
        validation['billing_zip']['valid'] = true;
        this.setState({
            client,
            validation
        }, () => {
            this.validateAllRequiredFields();
        });
    }

    handleChangeSplit = (e) => {
        let isSplit = { ...this.state.isSplit };
        isSplit = e.target.checked;;
        this.setState({ isSplit });
    }

    validate = (value, name, validationRegEx, e) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[name]['valid'] = isValid;
        this.setState({ validation }, () => { this.validateRequiredField(e) });
    }

    validateRequiredField = (e) => {
        const validation = { ...this.state.validation };
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[name]['msg'] = strings.errorRequired;
            validation[name]['valid'] = false;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.filter((item, index) => item.valid !== 'undefined').length;
        for (let type in validation) {
            if (validation[type]['valid']) {
                i--;
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    updateClient = () => {
        this.setMessage('', '', 'loading');
        const data = { ...this.state.client };
        data['shipping_fee'] = undefined;

        (async () => {
            try {
                // Check if url_short_name already exists
                const responseUrl = await checkURL(data.url_short_name);
                console.log(responseUrl);
                if(data.exists){
                    this.setMessage(window.general_strings.msg.oops, strings.urlAlreadyExist, 'error');
                } else {
                    const response = await putUpdatedClient(data);
                    if (response.data.error) {
                        let string = '';
                        if (response.data.error.details) {
                            response.data.error.details.forEach((detail) => {
                                string += detail.field + ' - ' + detail.message + '<br />';
                            });
                        } else {
                            string += `${response.data.error.code} - ${response.data.error.message}`;
                        }
                        
                        
                        this.setMessage(window.general_strings.msg.oops, string, 'error');
                        window.scroll(0,0);
                    } else {
                        this.setMessage(window.general_strings.msg.yay, 'Your settings have been updated.', 'success');
                        console.log('Client Update Response: ', response);

                        (async () => {
                            try {
                                const response = await getCurrentClient();
                                console.log('Current Client Response: ', response);
                                this.setState({ client: response.data.client || {} });
                            } catch (error) {
                                console.log(error);
                            }
                        })()
                
                        async function getCurrentClient() {
                            return await ApiRequest('/clients/current');
                        }
                    }
                }
            } catch (error) {
                this.setMessage(window.general_strings.msg.oops, error, 'error');
                window.scroll(0,0);
            }
        })()

        async function putUpdatedClient(data) {
            return await ApiRequest('/clients/current', {
                method: 'put',
                data
            });
        }

        async function checkURL(url_short_name) {
            return await ApiRequest(`/clients/url-short-name/${url_short_name}/exists`, {
                method: 'get'
            });
        }
    }

    getParams = async () => {
        this.setMessage('', '', 'loading');
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const token = urlParams.get('state');
        if (code && token) {
            this.setState({
                code,
                token,
            });
            try {
                const urlResponse = await postURL(code, token);
                console.log('urlResponse: ', urlResponse);
                if (urlResponse.data.success) {
                    this.setMessage(window.general_strings.msg.yay, 'Account successfully linked', 'success');
                    this.getStripeURL();
                } else {
                    if (urlResponse.data.error.code === 'client-has-existing-stripe-account') {
                        this.setMessage(window.general_strings.msg.oops, 'Account already linked', 'error');
                    } else {
                        this.setMessage(window.general_strings.msg.oops, urlResponse.data.error.message, 'error');
                    }
                }
                
                
            } catch (error) {
                console.log(error);
            }
        } else {
            this.setMessage('', '', '');
        }

		async function postURL(code, token) {
			return await ApiRequest(`/stripe/onboarding`, {
                method: 'POST',
                data: {
                    code,
                    token,
                }
            });
        }
    }

    getStripeURL = async () => {
        try {
            const accountsResponse = await getAccounts();
            this.setState({
                stripe_accounts: accountsResponse.data.stripe_accounts
            } , () => {
                this.getSignups();
                this.getDashboards();
                this.setPayout();
            });
        } catch (error) {
            console.log(error);
        }

		async function getAccounts() {
			return await ApiRequest(`/clients/current/stripe-accounts`, {
                method: 'GET'
            });
        }
    }

    setPayout = () => {
        let client = this.state.client;
        let stripe_accounts = this.state.stripe_accounts;

        if (stripe_accounts.length >= 1) {
            client.payout_option = 'recurring-deposit';
        }

        this.setState({
            client,
        });
    }

    getSignups = async () => {
        try {
            const eventResponse = await getEventURL();
            console.log('eventResponse: ', eventResponse);
            if (eventResponse.data.url) {
                this.setState({
                    stripe_url_event: eventResponse.data.url
                });
            }

            const donationResponse = await getDonationURL();
            console.log('donationResponse: ', donationResponse);
            if (donationResponse.data.url) {
                this.setState({
                    stripe_url_donation: donationResponse.data.url
                });
            }
        } catch (error) {
            console.log(error);
        }

        async function getEventURL() {
			return await ApiRequest(`/stripe/onboarding/url?type=connect`, {
                method: 'GET'
            });
        }

        async function getDonationURL() {
			return await ApiRequest(`/stripe/onboarding/url?type=connect-alt`, {
                method: 'GET'
            });
        }
    }

    getDashboards = () => {
        let stripe_accounts = this.state.stripe_accounts;
        const getDashboard = async () => {
			try {
                for (let account of stripe_accounts) {
                    if (account.type === 'connect') {
                        let eventResponse = await regular();
                        console.log('eventResponse: ', eventResponse);
                        account.dashboard = eventResponse.data.url;
                    }
                    
                    if (account.type === 'connect-alt') {
                        let donationResponse = await donation();
                        console.log('donationResponse: ', donationResponse);
                        account.dashboard = donationResponse.data.url;
                    }
                }

                console.log('stripe_accounts', stripe_accounts)
                this.setState({
                    stripe_accounts,
                });

			} catch (error) {
				console.log(error);
			}
		};

		async function regular() {
			return await ApiRequest(`/stripe/dashboard/url?type=connect`, {
                method: "GET"
            });
        }
        
        async function donation() {
			return await ApiRequest(`/stripe/dashboard/url?type=connect-alt`, {
                method: "GET"
            });
		}
		getDashboard();
    }

    componentDidMount = () => {
        (async () => {
            try {
                let original_payout_option = this.state.original_payout_option;
                let response = await getCurrentClient();
                console.log('Current Client Response: ', response);
                if (!response.data.client.payout_option) {
                    response.data.client.payout_option = 'check-at-close';
                }
                original_payout_option = response.data.client.payout_option;
                this.setState({ 
                    client: response.data.client || {},
                    original_payout_option,
                });
            } catch (error) {
                console.log(error);
            }
        })()

        async function getCurrentClient() {
            return await ApiRequest('/clients/current');
        }

        let validation = { ...this.state.validation };
        for (let type in validation) {
            validation[type]['valid'] = true;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());

        this.getStripeURL();
        this.getParams();
        this.getDashboards();
    }

    componentWillReceiveProps(props) {
        if(props.isUpdateClient){
            this.updateClient();
        }
    }

    renderW9Message = () => {
        const client = this.state.client;
        if (client.billing_country === 'US' && !client.tax_1099_received) {
            let message = {
                title: 'Warning',
                content: '<p>Our records indicate we do not have a W9 on file for your organization. Before payment can be sent, we will need this informational tax document. This is required even for non-profit, tax exempt, and government entities.</p><p>To ensure a secure platform and to comply with federal tax regulations, we are required to have your organization\'s W9. For more information on why a W9 is needed and how it is used visit: <a href="https://showtix4u.zendesk.com/hc/en-us/articles/360055496972-Arts-Organization-Why-do-you-need-a-W9-and-where-do-I-submit-it-?" target="_blank">Arts Organization > Why do you need a W9 and where do I submit it?</a></p>',
            }
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Help help={message} />
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                <form>
                    {this.renderW9Message()}
                    <ClientInfo 
                        client={this.state.client} 
                        original_payout_option={this.state.original_payout_option}
                        handleChange={this.handleChange}
                        handleChangePayout={this.handleChangePayout}
                        handleBillingAddressChange={this.handleBillingAddressChange}
                        handleFullBillingAddressChange={this.handleFullBillingAddressChange}
                        validateRequiredField={this.validateRequiredField}
                        validation={this.state.validation} 
                        isReadyToSubmit={this.state.isReadyToSubmit}
                        updateClient={this.updateClient}
                        stripe_url_event={this.state.stripe_url_event}
                        stripe_url_donation={this.state.stripe_url_donation}
                        stripe_accounts={this.state.stripe_accounts}
                        isSplit={this.state.isSplit}
                        handleChangeSplit={this.handleChangeSplit}
                    />
                </form>
            </React.Fragment>
        );
    }
}

Billing.propTypes = {
}

export default Billing;



// WEBPACK FOOTER //
// ./src/components/Client/Billing/Billing.js